module.exports = __webpack_public_path__ + "6ba874a9f94abe2526cbe13b9611e341.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-4.png
// module id = 3125
// module chunks = 0